export default __webpack_public_path__ + "static/media/SpaceCat-keytar.55c5407c.gif";